<template>
  <div style="width: 100%;max-width: 100%;">
    <v-card class="gradient-primary" flat>
      <v-card-title class="pa-3">
        <div class="header-content">
          <div class="header-left">
            <v-avatar size="32" color="white" class="mr-4">
              <v-icon color="dark" size="24">mdi-basket-outline</v-icon>
            </v-avatar>
            <div style="flex: 1 1 0%;">
              <h1 class="text-h4 font-weight-bold white--text mb-1">
                Proveedores de Materia Prima
              </h1>
              <!-- <p class="text-subtitle1 white--text opacity-80 mb-0">
                    Gestión y confirmación de recibos de pagos
                  </p> -->
            </div>
          </div>
          <v-text-field v-model="filter.Search" placeholder="Buscar transportistas..." prepend-inner-icon="mdi-magnify"
            outlined dense hide-details class="search-field-header" clearable dark color="white"
            @click:clear="filter.Search = ''">
          </v-text-field>
        </div>
      </v-card-title>
    </v-card>

    <s-crud title="" :filter="filter" noSearch height="400" :config="config" add @save="saveForm($event)"
      @addEvent="openDialog()" :edit="selected.length > 0" @EditEvent="editEvent" @rowSelected="rowSelected($event)"
      remove @dblClick="dblclick($event)" ref="crudrms">

      <template v-slot:item.Status="{ item }">
        <v-chip :color="getColor(item.Status)" x-small outlined class="white--text px-1">
          {{ item.StatusText }}
        </v-chip>
      </template>
      <template v-slot:item.FagName="{ item }">
        <div class="pa-2 ma-0 text-start" style="min-width: 180px;">
          <p class="pa-0 text-base ma-0">{{ item.FagName }}</p>
          <p class="pa-0 text-base ma-0">{{ item.FltName }}</p>
        </div>
      </template>
      <template v-slot:item.TypeCultiveText="{ item }">
        <div class="pa-2 ma-0 text-cebter">
          <p class="pa-0 text-base ma-0">{{ item.TypeCropText }}</p>
          <p class="pa-0 text-base ma-0">{{ item.TypeCultiveText }}</p>
        </div>
      </template>
      <template v-slot:item.AuditReport="{ item }">
        <div v-if="item.AuditReport == '1'" class="text-center pa-0">SI</div>
      </template>
      <template v-slot:item.TechnicalReport="{ item }">
        <div v-if="item.TechnicalReport == '1'" class="text-center pa-0">SI</div>
      </template>
      <template v-slot:item.CanExportToChina="{ item }">
        <div v-if="item.CanExportToChina == '1'" class="text-center pa-0">SI</div>
      </template>

      <template v-slot:filter>
        <v-row class="pa-3 pt-0" dense>
          <v-col cols="12" sm="4" md="3" lg="2">
            <s-select-campaign-area label="Campaña" v-model="filter.CmaID" clearable noDefault
              typeArea="1"></s-select-campaign-area>
          </v-col>
          <v-col cols="12" sm="4" md="3" lg="2">
            <s-select-definition :def="1605" label="Estado Aprobación" noDefault v-model="filter.Status"
              clearable></s-select-definition>
          </v-col>
          <!-- <v-col cols="12" sm="4" md="3" lg="2">
            <s-select-definition :def="1605" label="Estado Aprobación" noDefault v-model="filter.TypeCrop"
              clearable></s-select-definition>
          </v-col> -->
          <!-- <v-col cols="12" sm="4" md="3" lg="2">
            <s-select-definition :def="1605" label="Estado Aprobación" noDefault v-model="filter.TypeCultive"
              clearable></s-select-definition>
          </v-col> -->
          <v-col cols="12" sm="4" md="4" lg="2">
            <s-date label="Fecha" v-model="filter.BeginStart" clearable dense hide-details></s-date>
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="2">
            <s-date label="Fecha Hasta" v-model="filter.BeginDate" clearable dense hide-details></s-date>
          </v-col>
        </v-row>
      </template>

      <v-dialog v-model="dialog" max-width="1200" scrollable persistent :retain-focus="false">
        <v-card class="elevation-10">
          <v-toolbar color="primary" dark flat dense>
            <v-toolbar-title class="text-h6">
              <v-icon left>mdi-file-document-edit</v-icon>
              {{ form.RmsID == 0 ? 'REGISTRAR' : 'ACTUALIZAR' }} PROVEEDOR DE MATERIA PRIMA
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4" style="height: 75vh;">
            <v-form ref="formRefactorizado">
              <h3 class="mb-3 text-h6 primary--text">
                <v-icon small left>mdi-account-details</v-icon>
                Información Principal
              </h3>
              <v-row dense>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-select-campaign-area label="Campaña" v-model="form.CmaID" clearable noDefault
                    typeArea="1"></s-select-campaign-area>
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <s-select-definition :def="1605" label="Estado Aprobación" noDefault v-model="form.Status"
                    clearable></s-select-definition>
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <s-search-lot-by-cod-senasa clearable v-model="form.CodSenasa" @searchSenasa="searchSenasa($event)" />
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="5">
                  <s-text readonly disabled label="Productor" :value="form.PrdText" ref="PrdText"></s-text>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <s-text readonly disabled label="Fundo" :value="`${form.FagName} LOTE : ${form.FltName}`"
                    ref="Fundo"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text readonly disabled label="Tipo de Fruta" :value="form.TypeCropText"
                    ref="TypeCropText"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text readonly disabled label="Tipo de Cultivo" :value="form.TypeCultiveText"
                    ref="TypeCultiveText"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <s-text readonly disabled label="Variedad" :value="form.VrtIDText" ref="VrtIDText"></s-text>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4">
                  <s-text readonly disabled label="Zona" :value="form.ZonIDText" ref="ZonIDText"></s-text>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" md="8">
                  <v-row dense>
                    <v-col cols="12" sm="6" md="6" lg="4">
                      <v-switch v-model="form.AuditReport" label="¿Tiene Reporte de Auditoría?" color="success"
                        false-value="0" true-value="1" inset></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="4">
                      <v-switch v-model="form.TechnicalReport" label="¿Tiene Reporte Técnico?" color="success"
                        false-value="0" true-value="1" inset></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <h3 class="mb-3 text-h6 primary--text">
                <v-icon small left>mdi-certificate</v-icon>
                Fechas de Certificación
              </h3>
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="3">
                  <s-date label="Fecha GlobalGap" v-model="form.GlobalGapFv" clearable dense hide-details
                    ref="GlobalGapFv"></s-date>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text label="Certificación Orgánica" v-model="form.OrganicFv" ref="OrganicFv"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text label="Certificación Rainforest" v-model="form.RainforestFv" ref="RainforestFv"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text label="GraspFv" v-model="form.GraspFv" ref="GraspFv"></s-text>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="3">
                  <s-text label="SmetaFv" v-model="form.SmetaFv" ref="SmetaFv"></s-text>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <h3 class="mb-3 text-h6 primary--text">
                <v-icon small left>mdi-test-tube</v-icon>
                Límites de Metales y Residuos
              </h3>
              <v-row dense>
                <v-col cols="12" sm="3" md="3" lg="2">
                  <s-text label="Límite Metales Pesados" suffix="kg" v-model="form.HeavyMetalsLimit"
                    ref="HeavyMetalsLimit" type="number"></s-text>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="2">
                  <s-text label="Cadmio" suffix="ppm" v-model="form.CadmiumPpm" ref="CadmiumPpm" type="number"></s-text>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="2">
                  <s-text label="Plomo" suffix="ppm" v-model="form.LeadPpm" ref="LeadPpm" type="number"></s-text>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                  <s-date label="Fecha Análisis de Pesticidas (Hasta)" v-model="form.PesticideAnalysisLimit" clearable
                    dense hide-details ref="PesticideAnalysisLimit"></s-date>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <s-text label="Residuos - trazas" suffix="ppm" v-model="form.TraceResiduePpm" type="number"
                    ref="TraceResiduePpm"></s-text>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <h3 class="mb-3 text-h6 primary--text">
                <v-icon small left>mdi-alert-octagon</v-icon>
                Restricciones y Acciones
              </h3>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <s-text label="Destino donde no se puede exportar" v-model="form.RestrictedExportDestination"
                    ref="RestrictedExportDestination"></s-text>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <s-text label="Cliente que no se debe procesar" v-model="form.RestrictedClient"
                    ref="RestrictedClient"></s-text>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3">
                  <v-switch v-model="form.CanExportToChina" label="¿Puede Exportar a China?" color="primary"
                    false-value="0" true-value="1" inset></v-switch>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <s-textarea label="Comentario Operación Agrícola" v-model="form.CommentaryAgriculturalOperation"
                    ref="CommentaryAgriculturalOperation" :rows="2"></s-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <s-textarea label="Acción Correspondiente" v-model="form.CorrespondingAction"
                    ref="CorrespondingAction" :rows="2"></s-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <s-textarea label="Observación General" v-model="form.Observation" ref="Observation"
                    :rows="2"></s-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="elevation-3 py-3 px-6">
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="resetForm, dialog = false">
              <v-icon left>mdi-cancel</v-icon>
              Cancelar
            </v-btn>
            <v-btn color="primary" class="ml-2" @click="saveForm()">
              <v-icon left>mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </s-crud>
  </div>
</template>

<script>

import _RawMaterialSupplierService from '@/services/Quality/RawMaterialSupplierService';
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectDefinition from '@/components/Utils/SSelectDefinition.vue';
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";

export default {
  components: { SSelectDefinition, SSelectCampaignArea, SSearchLotByCodSenasa, },
  data() {
    return {
      dialog: false,
      selected: [],
      filter: {
        Search: '',
        CmaID: null,
        TypeCrop: null,
        TypeCultive: null,
        Status: null,
        BeginStart: '',
        BeginDate: ''
      },
      config: {
        model: {
          RmsID: "ID",
          CorrespondingAction: "string",
          Observation: "string",
          CanExportToChina: "string",
          PesticideAnalysisLimit: "date",
          GlobalGapFv: "date",
          SecCreate: "date",
          Options: ""
        },
        service: _RawMaterialSupplierService,
        headers: [
          { text: "ID", value: "RmsID", width: 40, align: "center" },
          { text: "ESTADO", value: "Status", align: 'center' },
          { text: "PRODUCTOR", value: "PrdText", align: "left", width: 140 },
          { text: "FUNDO", value: "FagName", width: 40, align: "center" },
          { text: "VARIEDAD", value: "VrtIDText", align: "center" },
          { text: "TIPO DE CULTIVO", value: "TypeCultiveText", align: "center" },
          { text: "LOCALIDAD", value: "ZonIDText", align: "center" },
          { text: "CAMPAÑA", value: "CmaName", align: "center", width: 100 },
          { text: "REPORTE DE AUDITORIA", value: "AuditReport", width: 100, align: "center" },
          { text: "GLOBAL GAP (FV)", value: "GlobalGapFv", width: 100, align: "center" },
          { text: "ORGÁNICO (FV)", value: "OrganicFv", width: 70, align: "center" },
          { text: "RAINFOREST (FV)", value: "RainforestFv", width: 70, align: "center" },
          { text: "GRASP (FV)", value: "GraspFv", width: 70, align: "center" },
          { text: "SMETA (FV)", value: "SmetaFv", width: 70, align: "center" },
          { text: "REPORTE TÉCNICO", value: "TechnicalReport", width: 70, align: "center" },
          { text: "METALES PESADOS (Hasta)", value: "HeavyMetalsLimit", width: 130, align: "center" },
          { text: "CADMIO (ppm)", value: "CadmiumPpm", width: 70, align: "center" },
          { text: "PLOMO (ppm)", value: "LeadPpm", width: 70, align: "center" },
          { text: "ANÁLISIS DE PESTICIDAS (FV)", value: "PesticideAnalysisLimit", width: 100 },
          { text: "RESIDUOS TRAZA (ppm)", value: "TraceResiduePpm", width: 120 },
          { text: "DESTINO DONDE NO SE PUEDE EXPORTAR", value: "RestrictedExportDestination", width: 140 },
          { text: "CLIENTE QUE NO SE DEBE PROCESAR", value: "RestrictedClient", width: 120 },
          { text: "PUEDE EXPORTAR A CHINA", value: "CanExportToChina", width: 110, },
          { text: "COMENTARIO OPERACIÓN AGRÍCOLA", value: "CommentaryAgriculturalOperation", width: 160 },
          { text: "ACCIÓN CORRESPONDIENTE", value: "CorrespondingAction", width: 160 },
          { text: "OBSERVACIÓNES", value: "Observation" },
        ],
      },
      form: {
        CodSenasa: "",
        RmsID: 0,
        PrdID: null,
        PrdText: null,
        FagName: null,
        FltID: null,
        FltName: null,
        CmaID: null,
        TypeCropText: null,
        TypeCultiveText: null,
        VrtIDText: null,
        ZonIDText: null,
        AuditReport: '0',        // Switch: '0' o '1'
        GlobalGapFv: "",       // Date
        OrganicFv: null,
        RainforestFv: null,
        GraspFv: null,
        SmetaFv: null,
        TechnicalReport: '0',    // Switch: '0' o '1'
        HeavyMetalsLimit: null,  // Number
        CadmiumPpm: null,        // Number
        LeadPpm: null,           // Number
        PesticideAnalysisLimit: "", // Date
        TraceResiduePpm: null,
        RestrictedExportDestination: null,
        RestrictedClient: null,
        CanExportToChina: '0',   // Switch: '0' o '1'
        CommentaryAgriculturalOperation: null,
        CorrespondingAction: null,
        Observation: null,
        Status: 0,
        UsrCreateID: 0
      },
    };
  },
  watch: {
    "form.FltID"(newVal) {
      if (newVal == null || newVal == '') {
        this.form.PrdID = null;
        this.form.PrdText = null;
        this.form.FagName = null;
        this.form.FltID = null;
        this.form.FltName = null;
        this.form.TypeCropText = null;
        this.form.TypeCultiveText = null;
        this.form.VrtIDText = null;
        this.form.ZonIDText = null;
      }
    }
  },
  methods: {
    openDialog() {
      this.resetForm();
      this.dialog = true;
    },
    closeDialog() {
      this.$refs.crudrms.refresh();
      this.dialog = false;
    },
    searchSenasa(item) {
      if (item) {
        // console.log(item)
        this.form.PrdID = item ? item.PrdID : null;
        this.form.PrdText = item ? item.PrdText : null; //PrdCardName
        this.form.FltID = item ? item.FltID : null;
        this.form.FltName = item ? item.FltName : null;
        this.form.FagName = item ? item.FagName : null;
        this.form.TypeCropText = item ? item.TypeCropText : null;
        this.form.TypeCultiveText = item ? item.TypeCultiveText : null;
        this.form.VrtIDText = item ? item.VrtIDText : null;
        this.form.ZonIDText = item ? item.ZonIDText : null; //FagAddress
      }
    },
    saveForm() {
      if (this.form.CmaID == undefined || this.form.CmaID == "") {
        this.$fun.alert("SELECCIONAR CAMPAÑA", "warning");
        return;
      }
      if (this.form.Status == 0 || this.form.Status == "") {
        this.$fun.alert("SELECCIONAR ESTADO DE APROVACIÓN", "warning");
        return;
      }
      if (this.form.PrdID == undefined || this.form.PrdID == "") {
        this.$fun.alert("SELECCIONAR PRODUCTOR", "warning");
        return;
      }
      if (this.form.FltID == undefined || this.form.FltID == "") {
        this.$fun.alert("NO SE HA SELECCIONADO EL FUNDO", "warning");
        return;
      }
      if (this.form.PesticideAnalysisLimit == "") {
        this.form.PesticideAnalysisLimit = null
      }

      const mensaje = this.form.RmsID == 0 ? "¿Seguro de Guardar?" : "¿Seguro de Actualizar?";
      this.$fun.alert(mensaje, "question").then((val) => {
        if (val.value) {

          const UsrCreateID = this.$fun.getUserID();
          this.form.UsrCreateID = UsrCreateID;
          const { CodSenasa, PrdText, FagName, FltName, TypeCropText, TypeCultiveText, VrtIDText, ZonIDText, ...formData } = this.form;
          console.log('Datos a guardar:', formData);

          _RawMaterialSupplierService.save(formData, UsrCreateID).then((response) => {
            // console.log(response);
            if (response.status == 200) {
              this.$fun.alert("Datos guardados correctamente", "success");
              this.$refs.crudrms.refresh();
              this.closeDialog();
            }
          }).catch((error) => {
            if (error.response) {
              this.$fun.alert(error.response.data.Message, "error");
            } else if (error.request) {
              console.error('No hubo respuesta del servidor');
              this.$fun.alert("No hubo respuesta del servidor", "error");
            } else {
              console.error('Error al configurar la solicitud:', error.message);
              this.$fun.alert("Error al guardar los datos: " + error.message, "error");
            }
          });
        }
      })
    },
    editEvent(item) {
      this.selected = item;
      this.form = { ...item[0] }
      this.form.CodSenasa = item[0].FltID ? item[0].FltID.toString() : "";
      this.$emit("searchSenasa", item);
      this.dialog = true;
    },
    rowSelected(item) {
      this.selected = item;
    },
    dblclick(item) {
      this.form = { ...item }
      this.form.CodSenasa = item.FltID ? item.FltID.toString() : "";
      this.$emit("searchSenasa", item);
      this.dialog = true;
    },
    resetForm() {
      this.form = {
        CodSenasa: "",
        RmsID: 0,
        PrdID: null,
        PrdText: null,
        FagName: null,
        FltID: null,
        FltName: null,
        CmaID: null,
        TypeCropText: null,
        TypeCultiveText: null,
        VrtIDText: null,
        ZonIDText: null,
        AuditReport: '0',        // Switch: '0' o '1'
        GlobalGapFv: "",       // Date
        OrganicFv: null,
        RainforestFv: null,
        GraspFv: null,
        SmetaFv: null,
        TechnicalReport: '0',    // Switch: '0' o '1'
        HeavyMetalsLimit: null,  // Number
        CadmiumPpm: null,        // Number
        LeadPpm: null,           // Number
        PesticideAnalysisLimit: "", // Date
        TraceResiduePpm: null,
        RestrictedExportDestination: null,
        RestrictedClient: null,
        CanExportToChina: '0',   // Switch: '0' o '1'
        CommentaryAgriculturalOperation: null,
        CorrespondingAction: null,
        Observation: null,
        Status: 0, // Podría ser un select o predefinido.
        UsrCreateID: 0
      }
    },
    getColor(value) {
      let color = ''
      switch (value) {
        case 1: color = 'green'; break
        case 2: color = 'orange'; break
        case 3: color = 'red'; break
        default: color = 'primary'; break
      }
      return color
    },
  },
}
</script>

<style scoped>
.gradient-primary {
  background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-left {
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1 1 0%;
}

.header-right {
  display: flex;
  justify-items: center;
  align-items: center !important;
  min-width: 300px;
}

.search-field-header {
  padding: 8px;
  align-items: center !important;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 1rem;
  max-width: 250px;
}

.search-field-header>>>.v-input__slot {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

@media (max-width:768px) {
  .header-content {
    flex-direction: column;
  }

  .search-field-header {
    width: 100%;
    max-width: 80%;
  }
}
</style>